import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { ZonalManagerDonationsPage } from '@/features/marketPromotion/pages/ZonalManagerDonationsPage';
import { zonalManagerDonationsSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute(
  '/_auth/market-promotion/publish-panel/zonal-managers/$userId',
)({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.PUBLISH_PANEL_VIEW),
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: zonalManagerDonationsSearchSchema,
  component: function ZonalManagerDonationsRoute() {
    const { userId } = Route.useParams();
    const search = Route.useSearch();
    return (
      <ErrorBoundary moduleName="ZM Donations">
        <Suspense fallback={<PageLoader />}>
          <ZonalManagerDonationsPage userId={userId} search={search} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
